<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Editar Grupo</p>
    </div>

    <q-form ref="myForm" class="q-pa-md q-mt-sm">
      <div class="row col-12 q-col-gutter-sm">
        <div
          class="col-lg-2 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Nome do Grupo
          <q-input
            :bg-color="editar ? '' : 'brand-7'"
            :disable="!editar"
            dense
            outlined
            v-model="dados.nome"
          />
        </div>

        <div
          class="col-lg-3 col-md-4 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Descrição
          <q-input
            :disable="!editar"
            dense
            outlined
            v-model="dados.descricao"
            :bg-color="editar ? '' : 'brand-7'"
          />
        </div>

        <div class="col-lg-1 col-md-2 col-sm-12 col-xs-12">
          <p></p>
          <q-btn
            dense
            class="q-mt-sm full-width"
            :color="editar ? 'positive' : 'primary'"
            :label="editar ? 'Salvar' : 'Editar'"
            no-caps
            :icon="editar ? 'check_circle_outline' : 'edit'"
            @click="editar ? editarGrupo() : (editar = true)"
          />
        </div>
      </div>
    </q-form>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  name: "EditarFerramenta",

  setup() {
    const $q = useQuasar();
    const $route = useRoute();
    const uuid = $route.params.uuid;
    const router = useRouter();
    const myForm = ref(null);
    const store = useStore();
    let editar = ref(false);
    const grupo = ref({});
    const dados = ref({});

    const detalharCategoria = async () => {
      try {
        const response = await store.dispatch("fer/detalharCategoria", {
          categoriaUuid: uuid,
        });
        grupo.value = response.data.result;
        dados.value = { ...grupo.value };
      } catch (error) {
        console.log(error);
      }
    };

    let editarGrupo = async () => {
      if (
        dados.value.nome == grupo.value.nome &&
        dados.value.descricao == grupo.value.descricao
      ) {
        editar.value = false;
        return;
      }
      try {
        await store.dispatch("fer/editarCategoria", {
          categoriaUuid: uuid,
          nome: dados.value.nome,
          descricao: dados.value.descricao,
        });

        $q.notify({
          message: "Dados Alterados!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({ name: "cadastrarGrupo" });
      } catch (error) {
        $q.notify({
          message: "Erro ao alterar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(() => {
      detalharCategoria();
    });

    return {
      grupo,
      myForm,
      detalharCategoria,
      editarGrupo,
      editar,
      dados,
    };
  },
};
</script>
